<template>
  <div class="message-crew-select-contact-item--item" test-id="crew" @click="onClick">
    <div class="message-crew-select-contact--outer-wrapper">
      <div class="message-crew-select-contact-item--info-wrapper">
        <p class="has-text-weight-bold">{{ contractorName }}</p>
        <p class="message-crew-select-contact-item--info">{{ item.contractor.name }}</p>
      </div>
      <div v-if="!screenSize.desktop" class="message-crew-select-contact-item--chevron-wrapper">
        <LsIcon type="chevron" size="md" />
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { mapState } from 'vuex';
import { LsIcon } from '@/components/common';

export default {
  name: 'MessageCrewSelectContactItem',
  components: { LsIcon },
  props: {
    item: VueTypes.shape({
      contractor: {
        name: VueTypes.string.isRequired,
      },
      first_name: VueTypes.string.isRequired,
      last_name: VueTypes.string.isRequired,
      user_id: VueTypes.number.isRequired,
    }).isRequired.loose,
  },

  computed: {
    ...mapState(['screenSize']),
    contractorName() {
      return `${this.item.first_name} ${this.item.last_name}`;
    },
  },
  methods: {
    onClick() {
      this.$emit('click', {
        conversation_id: _.get(this.item, 'conversation_id', null),
        contractorUserId: this.item.user_id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.message-crew-select-contact-item--item {
  width: 100%;
  min-height: 90px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding-bottom: 6px;
}

.message-crew-select-contact--outer-wrapper {
  display: flex;
  justify-content: space-between;
}

.message-crew-select-contact-item--info-wrapper {
  padding: 10px;
}

.message-crew-select-contact-item--info {
  font-size: $size-6;
}
.message-crew-select-contact-item--badges {
  padding-left: 10px;
  display: inline-block;
}

.message-crew-select-contact-item--chevron-wrapper {
  padding: 10px 10px 0;
}

@media (max-width: $mobile-max-width) {
  .message-crew-select-contact-item--item {
    &:hover {
      background-color: $primary-light;
    }
  }
}
.themed-app {
  .message-crew-select-contact-item--info {
    font-size: $theme-txt-body-sm;
  }
  @media (max-width: $mobile-max-width) {
    .message-crew-select-contact-item--item {
      &:hover {
        background-color: $theme-color-primary-light;
      }
    }
  }
}
</style>
